import { generateResourceReducer } from '../generators/resource.reducer';

import * as types from './meeting.types';
import * as constants from './meeting.constants';

export const meetingReducer = generateResourceReducer<types.IMeeting>({
  STORE: constants.STORE_MEETING,
  CLEAR: constants.CLEAR_MEETING,
});
